export default __webpack_public_path__ + "static/media/cell-phone-integration.f33f1f3f.svg";